import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { FilterParams, generateFilterObject } from "@components/Features/catalog/catalog-utils";
import { AppState } from "@app/store/store";
import { getCreatedTime, sortValueToQueryParam } from "../lib";

export const useCatalogFilters = () => {
    const {
        engineVolumeFrom: engineVolumeFromValue,
        engineVolumeTo: engineVolumeToValue,
        wheel: wheelValue,
        priceFrom: priceFromValue,
        priceTo: priceToValue,
        mileageFrom: mileageFromValue,
        mileageTo: mileageToValue,
        horsePowerFrom: horsePowerFromValue,
        horsePowerTo: horsePowerToValue,
        generation: generationValue,
        ownersQntFrom: ownerQntFrom,
        ownersQntTo,
        sourceId,
        country,
        drive: driveValue,
        engineType: engineTypeValue,
        transmission: transmissionValue,
        body: bodyValue,
        yearFrom: yearFromValue,
        yearTo: yearToValue,
        model: modelValue,
        brand: brandValue,
        city: citiesValue,
        sellerType,
        hideNoImages,
        catalogTimeSort,
        catalogAllParamsSort
    } = useSelector((state: AppState) => state.filters);

    const [updateFilters, setUpdateFilters] = useState<FilterParams>({});
    const [createdTimePrev, setCreatedTimePrev] = useState<string | null>(null);

    const createdParamSort = sortValueToQueryParam(catalogAllParamsSort);

    useEffect(() => {
        setCreatedTimePrev(getCreatedTime(catalogTimeSort));
    }, [catalogTimeSort]);

    const [filters, setFilters] = useState<FilterParams>(() => {
        const initialFilters = generateFilterObject({
            brandValue: brandValue?.id,
            modelValue: modelValue?.id,
            generationValue: generationValue?.id,
            yearFromValue,
            yearToValue,
            engineVolumeFromValue,
            engineVolumeToValue,
            bodyValue,
            transmissionValue,
            engineTypeValue,
            driveValue,
            wheelValue,
            priceFromValue,
            priceToValue,
            mileageFromValue,
            mileageToValue,
            horsePowerFromValue,
            horsePowerToValue,
            ownerQntFrom,
            ownersQntTo,
            citiesValue,
            sellerType,
            sourceId,
            country,
            hideNoImages
        });
        return {
            ...initialFilters,
            sort: sortValueToQueryParam(catalogAllParamsSort),
            created_at: getCreatedTime(catalogTimeSort)
        };
    });

    useEffect(() => {
        const newFilters = generateFilterObject({
            brandValue: brandValue?.id,
            modelValue: modelValue?.id,
            generationValue: generationValue?.id,
            yearFromValue,
            yearToValue,
            engineVolumeFromValue,
            engineVolumeToValue,
            bodyValue,
            transmissionValue,
            engineTypeValue,
            driveValue,
            wheelValue,
            priceFromValue,
            priceToValue,
            mileageFromValue,
            mileageToValue,
            horsePowerFromValue,
            horsePowerToValue,
            ownerQntFrom,
            ownersQntTo,
            citiesValue,
            sellerType,
            sourceId,
            country,
            hideNoImages
        });

        setUpdateFilters(newFilters);
    }, [
        brandValue,
        modelValue,
        yearFromValue,
        yearToValue,
        bodyValue,
        transmissionValue,
        engineTypeValue,
        driveValue,
        wheelValue,
        priceFromValue,
        priceToValue,
        mileageFromValue,
        mileageToValue,
        horsePowerFromValue,
        horsePowerToValue,
        generationValue,
        ownerQntFrom,
        ownersQntTo,
        citiesValue,
        engineVolumeFromValue,
        engineVolumeToValue,
        sellerType,
        sourceId,
        country,
        hideNoImages
    ]);

    return {
        filters,
        setFilters,
        updateFilters,
        createdTimePrev,
        createdParamSort,
        brandValue,
        modelValue,
        generationValue,
        citiesValue,
        bodyValue,
        priceFromValue,
        priceToValue,
        sourceId,
        country,
        catalogTimeSort,
        catalogAllParamsSort,
        yearFromValue,
        engineVolumeFromValue,
        transmissionValue,
        engineTypeValue,
        driveValue
    };
};